/**
 * Mother of Macros — Freeze Pack enforcement
 *
 * Freeze Pack product ID: 7378499862564
 * Freeze Pack variant ID: 40914461425700
 */
(function () {
  'use strict';

  if (window.__momFreezePackApplied) return;
  window.__momFreezePackApplied = true;

  var FREEZE_VARIANT_ID = 40914461425700;
  var FREEZE_PRODUCT_HANDLE = 'dry-ice-for-shipping';
  var INTERNAL_HEADER = 'X-MOM-Freeze-Pack';
  var MOM_BOX_ITEM_PROPERTY = '_mom_box_item';

  var MOM_BUILDER_PATHS = [
    '/products/60-pack',
    '/products/60-pack-nation-wide'
  ];

  function getMomNormalizedPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function isMomBuilderPage() {
    return MOM_BUILDER_PATHS.indexOf(getMomNormalizedPath()) !== -1;
  }

  var nativeFetch = window.fetch.bind(window);

  /*
   * Customer-specific cart expiration.
   */
  var CART_EXPIRY_STORAGE_KEY = 'mom_cart_last_activity';

  function getCartExpirationConfig() {
    var config = window.MOM_CART_EXPIRATION || {};
    var hours = parseFloat(config.hours);

    if (!isFinite(hours) || hours <= 0) {
      hours = 5;
    }

    return {
      enabled: config.enabled !== false,
      milliseconds: hours * 60 * 60 * 1000
    };
  }

  function readCartActivityTime() {
    try {
      return (
        parseInt(localStorage.getItem(CART_EXPIRY_STORAGE_KEY), 10) || 0
      );
    } catch (error) {
      return 0;
    }
  }

  function saveCartActivityTime() {
    try {
      localStorage.setItem(
        CART_EXPIRY_STORAGE_KEY,
        String(Date.now())
      );
    } catch (error) {
      // Ignore unavailable browser storage.
    }
  }

  function removeCartActivityTime() {
    try {
      localStorage.removeItem(CART_EXPIRY_STORAGE_KEY);
    } catch (error) {
      // Ignore unavailable browser storage.
    }
  }

  function isStoredCartExpired() {
    var config = getCartExpirationConfig();

    if (!config.enabled) return false;

    var lastActivity = readCartActivityTime();

    if (!lastActivity) return false;

    return Date.now() - lastActivity >= config.milliseconds;
  }

  var enforcementPromise = null;
  var enforcementRequested = false;

  function requestJSON(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';
    options.headers[INTERNAL_HEADER] = '1';

    return nativeFetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (message) {
          throw new Error(
            url + ' failed with ' + response.status + ': ' + message
          );
        });
      }

      return response.json();
    });
  }

  function getCart() {
    return requestJSON('/cart.js', {
      method: 'GET',
      cache: 'no-store'
    });
  }

  function updateCart(updates) {
    return requestJSON('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    });
  }

  function clearExpiredCart() {
    return requestJSON('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    }).then(function (cart) {
      removeCartActivityTime();
      return cart;
    });
  }

  function clearExpiredCartBeforeAdd() {
    if (!isStoredCartExpired()) {
      return Promise.resolve(false);
    }

    return clearExpiredCart().then(function () {
      return true;
    });
  }

  function addFreezePack() {
    return requestJSON('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: FREEZE_VARIANT_ID,
            quantity: 1,
            properties: {
              _hidden: 'true',
              _mom_box_freeze: 'true'
            }
          }
        ]
      })
    });
  }

  function isFreezePack(item) {
    return Number(item.variant_id) === FREEZE_VARIANT_ID;
  }

  /*
   * Only products added through either meal builder count as box meals.
   * Gift cards and normal store products are excluded.
   */
  function isNormalProduct(item) {
    return Boolean(
      item &&
        !isFreezePack(item) &&
        !item.gift_card &&
        item.properties &&
        String(item.properties[MOM_BOX_ITEM_PROPERTY]) === 'true'
    );
  }

  /*
   * Keep exactly one Freeze Pack with builder meals.
   * Remove it when no builder meals remain.
   */
  function normalizeFreezePack() {
    return getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      var freezeItems = cart.items.filter(isFreezePack);
      var normalItems = cart.items.filter(isNormalProduct);
      var updates = {};

      if (normalItems.length === 0) {
        freezeItems.forEach(function (item) {
          updates[item.key] = 0;
        });

        if (Object.keys(updates).length > 0) {
          return updateCart(updates);
        }

        return;
      }

      if (freezeItems.length === 0) {
        return addFreezePack();
      }

      freezeItems.forEach(function (item, index) {
        if (index === 0) {
          if (Number(item.quantity) !== 1) {
            updates[item.key] = 1;
          }
        } else {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length > 0) {
        return updateCart(updates);
      }
    });
  }

  /*
   * Queue enforcement so overlapping Shopify cart requests do not
   * create cart-lock errors.
   */
  function enforceFreezePack() {
    enforcementRequested = true;

    if (enforcementPromise) {
      return enforcementPromise;
    }

    function runNextCheck() {
      if (!enforcementRequested) return;

      enforcementRequested = false;

      return normalizeFreezePack().then(function () {
        return runNextCheck();
      });
    }

    enforcementPromise = Promise.resolve()
      .then(runNextCheck)
      .catch(function (error) {
        console.warn(
          '[MOM Freeze Pack] Enforcement skipped:',
          error
        );
      })
      .finally(function () {
        enforcementPromise = null;

        if (enforcementRequested) {
          setTimeout(enforceFreezePack, 0);
        }
      });

    return enforcementPromise;
  }

  window.MOMEnforceFreezePack = enforceFreezePack;

  function getRequestURL(input) {
    try {
      var value =
        typeof input === 'string'
          ? input
          : input && input.url;

      if (!value) return null;

      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isInternalRequest(input, options) {
    try {
      var headers =
        (options && options.headers) ||
        (input && input.headers);

      if (!headers) return false;

      if (typeof headers.get === 'function') {
        return Boolean(headers.get(INTERNAL_HEADER));
      }

      return Boolean(headers[INTERNAL_HEADER]);
    } catch (error) {
      return false;
    }
  }

  function isCartMutation(input) {
    var url = getRequestURL(input);

    if (!url) return false;

    return (
      /\/cart\/add(\.js)?$/.test(url.pathname) ||
      /\/cart\/change(\.js)?$/.test(url.pathname) ||
      /\/cart\/update(\.js)?$/.test(url.pathname) ||
      /\/cart\/clear(\.js)?$/.test(url.pathname)
    );
  }

  /*
   * Observe successful Shopify cart mutations.
   */
  window.fetch = function (input, options) {
    var requestArguments = Array.prototype.slice.call(arguments);
    var isMutation = isCartMutation(input);
    var isInternal = isInternalRequest(input, options);
    var requestURL = getRequestURL(input);
    var requestPath = requestURL ? requestURL.pathname : '';

    var isCartAdd = /\/cart\/add(\.js)?$/.test(requestPath);
    var isCartClear = /\/cart\/clear(\.js)?$/.test(requestPath);
    var responsePromise;

    /*
     * When the five-hour timer has expired, clear the old cart
     * before adding the customer's new product.
     */
    if (isCartAdd && !isInternal) {
      responsePromise = clearExpiredCartBeforeAdd().then(function () {
        return nativeFetch.apply(null, requestArguments);
      });
    } else {
      responsePromise = nativeFetch.apply(null, requestArguments);
    }

    try {
      if (isMutation && !isInternal) {
        responsePromise
          .then(function (response) {
            if (!response || !response.ok) return;

            if (isCartClear) {
              removeCartActivityTime();
            } else {
              saveCartActivityTime();
            }

            return enforceFreezePack();
          })
          .catch(function () {
            // The original calling script handles its own errors.
          });
      }
    } catch (error) {
      // Observer must never break the original cart request.
    }

    return responsePromise;
  };

  /*
   * Prevent removing the Freeze Pack while builder meals remain.
   */
  customElements.whenDefined('cart-items').then(function () {
    if (
      typeof CartItems === 'undefined' ||
      !CartItems.prototype ||
      CartItems.prototype.__momFreezeProtection
    ) {
      return;
    }

    var originalUpdateQuantity =
      CartItems.prototype.updateQuantity;

    CartItems.prototype.__momFreezeProtection = true;

    CartItems.prototype.updateQuantity = async function (
      line,
      quantity,
      name
    ) {
      var requestedQuantity = parseInt(quantity, 10);

      if (requestedQuantity === 0) {
        try {
          var cart = await getCart();
          var selectedItem =
            cart && Array.isArray(cart.items)
              ? cart.items[Number(line) - 1]
              : null;

          if (selectedItem && isFreezePack(selectedItem)) {
            var hasNormalProduct = cart.items.some(isNormalProduct);

            if (hasNormalProduct) {
              return;
            }
          }
        } catch (error) {
          console.warn(
            '[MOM Freeze Pack] Removal check skipped:',
            error
          );
        }
      }

      return originalUpdateQuantity.call(
        this,
        line,
        quantity,
        name
      );
    };
  });

  /*
   * Hide Freeze Pack quantity and removal controls.
   */
  var style = document.createElement('style');

  style.textContent =
    '.cart-item:has(a[href*="/products/' +
    FREEZE_PRODUCT_HANDLE +
    '"]) quantity-input,' +
    '.cart-item:has(a[href*="/products/' +
    FREEZE_PRODUCT_HANDLE +
    '"]) cart-remove-button {' +
    'display:none!important;' +
    '}' +
    'cart-remove-button button[aria-label*="Meal Guard Freeze Pack"] {' +
    'display:none!important;' +
    '}';

  document.head.appendChild(style);

  /*
   * Repair an existing cart when the page loads.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        setTimeout(enforceFreezePack, 500);
      }
    );
  } else {
    setTimeout(enforceFreezePack, 500);
  }

  /*
   * Detect whether the currently rendered drawer contains a meal.
   */
  function drawerHasNormalProduct() {
    var cartRows = Array.prototype.slice.call(
      document.querySelectorAll(
        '#CartDrawer-CartItems .cart-item'
      )
    );

    return cartRows.some(function (row) {
      return !row.querySelector(
        'a[href*="/products/dry-ice-for-shipping"]'
      );
    });
  }

  /*
   * Disable checkout temporarily if stale drawer HTML shows only
   * the Freeze Pack.
   */
  function updateFreezeOnlyCheckoutState() {
    var checkoutButton = document.getElementById(
      'CartDrawer-Checkout'
    );

    if (!checkoutButton) return;

    var hasNormalProduct = drawerHasNormalProduct();

    if (!hasNormalProduct) {
      if (!checkoutButton.disabled) {
        checkoutButton.dataset.momFreezeOnlyDisabled = 'true';
        checkoutButton.disabled = true;
      }

      checkoutButton.setAttribute('aria-disabled', 'true');
      return;
    }

    if (
      checkoutButton.dataset.momFreezeOnlyDisabled === 'true'
    ) {
      checkoutButton.disabled = false;
      checkoutButton.removeAttribute(
        'data-mom-freeze-only-disabled'
      );
      checkoutButton.removeAttribute('aria-disabled');
    }
  }

  function startFreezeOnlyCheckoutGuard() {
    var cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    updateFreezeOnlyCheckoutState();

    var drawerObserver = new MutationObserver(function () {
      updateFreezeOnlyCheckoutState();
    });

    drawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startFreezeOnlyCheckoutGuard
    );
  } else {
    startFreezeOnlyCheckoutGuard();
  }

  var freezeOnlyCheckoutStyle =
    document.createElement('style');

  freezeOnlyCheckoutStyle.textContent =
    '#CartDrawer-Checkout' +
    '[data-mom-freeze-only-disabled="true"] {' +
    'pointer-events:none!important;' +
    'cursor:not-allowed!important;' +
    'opacity:0.5!important;' +
    '}';

  document.head.appendChild(freezeOnlyCheckoutStyle);

  /*
   * Hard click protection when only the Freeze Pack remains.
   */
  document.addEventListener(
    'click',
    function (event) {
      var clickedElement = event.target;

      if (
        !clickedElement ||
        typeof clickedElement.closest !== 'function'
      ) {
        return;
      }

      var checkoutButton = clickedElement.closest(
        '#CartDrawer-Checkout'
      );

      if (checkoutButton && !drawerHasNormalProduct()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        checkoutButton.disabled = true;
        checkoutButton.setAttribute(
          'aria-disabled',
          'true'
        );
        checkoutButton.dataset.momFreezeOnlyDisabled = 'true';

        return false;
      }
    },
    true
  );

  /*
   * Block keyboard or app-triggered submission too.
   */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (
        form &&
        form.id === 'CartDrawer-Form' &&
        !drawerHasNormalProduct()
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var checkoutButton = document.getElementById(
          'CartDrawer-Checkout'
        );

        if (checkoutButton) {
          checkoutButton.disabled = true;
          checkoutButton.setAttribute(
            'aria-disabled',
            'true'
          );
          checkoutButton.dataset.momFreezeOnlyDisabled = 'true';
        }

        return false;
      }
    },
    true
  );

  /*
   * Builder checkout thresholds:
   * Local builder: 10 meals
   * Nationwide builder: 15 meals
   */
  function getMomMinimumMealCount() {
    var currentPath = getMomNormalizedPath();

    if (currentPath === '/products/60-pack-nation-wide') {
      return 15;
    }

    if (currentPath === '/products/60-pack') {
      return 10;
    }

    return 0;
  }

  function getMomDrawerMealCount() {
    var cartRows = Array.prototype.slice.call(
      document.querySelectorAll(
        '#CartDrawer-CartItems .cart-item'
      )
    );

    var mealCount = 0;

    cartRows.forEach(function (row) {
      var isFreezePackRow = Boolean(
        row.querySelector(
          'a[href*="/products/dry-ice-for-shipping"]'
        )
      );

      if (isFreezePackRow) return;

      var quantityInput = row.querySelector('.quantity__input');
      var quantity = quantityInput
        ? parseInt(quantityInput.value, 10)
        : 0;

      if (!isNaN(quantity) && quantity > 0) {
        mealCount += quantity;
      }
    });

    return mealCount;
  }

  function momMeetsMealThreshold() {
    if (!isMomBuilderPage()) return true;

    return (
      getMomDrawerMealCount() >= getMomMinimumMealCount()
    );
  }

  function updateMomMealThresholdCheckout() {
    var checkoutButton = document.getElementById(
      'CartDrawer-Checkout'
    );

    if (!checkoutButton) return;

    /*
     * The threshold must never run outside the two builders.
     */
    if (!isMomBuilderPage()) {
      var oldThresholdMessage = document.getElementById(
        'MomMealThresholdMessage'
      );

      if (oldThresholdMessage) {
        oldThresholdMessage.remove();
      }

      if (
        checkoutButton.dataset.momMealThresholdDisabled ===
          'true' &&
        checkoutButton.dataset
          .momMealThresholdPreviouslyDisabled !== 'true' &&
        checkoutButton.dataset.momFreezeOnlyDisabled !== 'true'
      ) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute('aria-disabled');
      }

      delete checkoutButton.dataset.momMealThresholdDisabled;
      delete checkoutButton.dataset
        .momMealThresholdPreviouslyDisabled;

      checkoutButton.removeAttribute('title');
      return;
    }

    var mealCount = getMomDrawerMealCount();
    var minimumMeals = getMomMinimumMealCount();
    var belowMinimum = mealCount < minimumMeals;
    var remainingMeals = Math.max(
      minimumMeals - mealCount,
      0
    );

    var thresholdMessage = document.getElementById(
      'MomMealThresholdMessage'
    );

    if (belowMinimum) {
      if (
        checkoutButton.dataset
          .momMealThresholdDisabled !== 'true'
      ) {
        checkoutButton.dataset
          .momMealThresholdPreviouslyDisabled =
          checkoutButton.disabled ? 'true' : 'false';
      }

      checkoutButton.dataset.momMealThresholdDisabled =
        'true';
      checkoutButton.disabled = true;
      checkoutButton.setAttribute(
        'aria-disabled',
        'true'
      );
      checkoutButton.setAttribute(
        'title',
        'Minimum ' +
          minimumMeals +
          ' meals required. You currently have ' +
          mealCount +
          '.'
      );

      if (!thresholdMessage) {
        thresholdMessage = document.createElement('small');
        thresholdMessage.id = 'MomMealThresholdMessage';
        thresholdMessage.style.display = 'block';
        thresholdMessage.style.margin = '8px 0 0';
        thresholdMessage.style.textAlign = 'center';
        thresholdMessage.style.color = '#c62828';
        thresholdMessage.style.fontSize = '13px';
        thresholdMessage.style.fontWeight = '600';
        thresholdMessage.style.lineHeight = '1.4';

        checkoutButton.insertAdjacentElement(
          'afterend',
          thresholdMessage
        );
      }

      var thresholdMessageText =
        'Add ' +
        remainingMeals +
        ' more ' +
        (remainingMeals === 1 ? 'meal' : 'meals') +
        ' to proceed to checkout.';

      if (
        thresholdMessage.textContent !== thresholdMessageText
      ) {
        thresholdMessage.textContent = thresholdMessageText;
      }

      return;
    }

    if (thresholdMessage) {
      thresholdMessage.remove();
    }

    var wasDisabledByThreshold =
      checkoutButton.dataset.momMealThresholdDisabled ===
      'true';

    var wasPreviouslyDisabled =
      checkoutButton.dataset
        .momMealThresholdPreviouslyDisabled === 'true';

    delete checkoutButton.dataset.momMealThresholdDisabled;
    delete checkoutButton.dataset
      .momMealThresholdPreviouslyDisabled;

    checkoutButton.removeAttribute('title');

    if (
      wasDisabledByThreshold &&
      !wasPreviouslyDisabled &&
      checkoutButton.dataset.momFreezeOnlyDisabled !== 'true'
    ) {
      checkoutButton.disabled = false;
      checkoutButton.removeAttribute('aria-disabled');
    }
  }

  var momMealThresholdStyle =
    document.createElement('style');

  momMealThresholdStyle.textContent =
    '#CartDrawer-Checkout' +
    '[data-mom-meal-threshold-disabled="true"] {' +
    'pointer-events:none!important;' +
    'cursor:not-allowed!important;' +
    'opacity:0.5!important;' +
    '}';

  document.head.appendChild(momMealThresholdStyle);

  /*
   * Hard click protection for the builder minimum.
   */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (
        !target ||
        typeof target.closest !== 'function'
      ) {
        return;
      }

      var checkoutButton = target.closest(
        '#CartDrawer-Checkout'
      );

      if (
        checkoutButton &&
        isMomBuilderPage() &&
        !momMeetsMealThreshold()
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        updateMomMealThresholdCheckout();
        return false;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (
        form &&
        form.id === 'CartDrawer-Form' &&
        isMomBuilderPage() &&
        !momMeetsMealThreshold()
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        updateMomMealThresholdCheckout();
        return false;
      }
    },
    true
  );

  function startMomMealThresholdGuard() {
    /*
     * Do not activate this observer on ordinary product pages.
     */
    if (!isMomBuilderPage()) return;

    var cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    updateMomMealThresholdCheckout();

    var thresholdObserver =
      new MutationObserver(function () {
        updateMomMealThresholdCheckout();
      });

    thresholdObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });

    cartDrawer.addEventListener('change', function () {
      setTimeout(updateMomMealThresholdCheckout, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startMomMealThresholdGuard
    );
  } else {
    startMomMealThresholdGuard();
  }

  /*
   * Make Freeze Pack links non-clickable.
   */
  var freezePackLinkStyle =
    document.createElement('style');

  freezePackLinkStyle.textContent =
    '.cart-item a[href*="/products/dry-ice-for-shipping"] {' +
    'pointer-events:none!important;' +
    'cursor:default!important;' +
    'text-decoration:none!important;' +
    '}';

  document.head.appendChild(freezePackLinkStyle);

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (
        !target ||
        typeof target.closest !== 'function'
      ) {
        return;
      }

      var freezePackLink = target.closest(
        'a[href*="/products/dry-ice-for-shipping"]'
      );

      if (freezePackLink) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  /*
   * Clear an expired cart when a customer returns to the site.
   */
  function checkExpiredCartOnPageLoad() {
    var config = getCartExpirationConfig();

    if (!config.enabled) return;

    getCart()
      .then(function (cart) {
        var hasItems =
          cart &&
          Array.isArray(cart.items) &&
          cart.items.length > 0;

        if (!hasItems) {
          removeCartActivityTime();
          return;
        }

        var lastActivity = readCartActivityTime();

        /*
         * Existing carts created before this feature receive a
         * fresh timer rather than being deleted immediately.
         */
        if (!lastActivity) {
          saveCartActivityTime();
          return;
        }

        if (!isStoredCartExpired()) return;

        return clearExpiredCart().then(function () {
          window.location.reload();
        });
      })
      .catch(function (error) {
        console.warn(
          '[MOM] Cart expiration check skipped:',
          error
        );
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      checkExpiredCartOnPageLoad
    );
  } else {
    checkExpiredCartOnPageLoad();
  }
})();